import { AI_MODEL_TYPE, AI_MODEL_OUTPUT, SUMMARIZE_PERIOD } from "../../../const/aimodel";
import * as Swal from "sweetalert2";

export default {
    props: ['aiData', 'aiSavingData', 'aiModeType', 'appName', 'appName2', 'isCreate', 'aiSummarizeDateField', 'summarizePeriod'],
    data() {
        return {
            aiModelOutputs: [],
            aiModelInputSelectedCodes: [],
            aiModelPredictFields: [],
            aiModelSummarizeFields: [],
            aiModelExogenousFields: [],
            search_input_field: '',
            search_output_predict_field: '',
            selectedAiModelOutput: null,
            aiModelSaved: []
        }
    },
    methods: {
        getDataInputAndOutput() {
            const outputs = this.mapKintoneField(this.aiModelOutputs);
            const inputs = this.allFields.filter((field) => {
                return this.aiModelInputSelectedCodes.indexOf(field.code) >= 0;
            });
            const inputsForPost = this.mapKintoneField(inputs);
            return {
                inputs: inputsForPost,
                outputs: outputs,
            }
        },
        mapKintoneField(data) {
            return data.map((field, index) => {
                return {
                    "index": index,
                    "kintone_field_name": field.label,
                    "kintone_field_code": field.code,
                    "kintone_field_type": field.type,
                    "type": field.output_type ?? AI_MODEL_OUTPUT.predict_field,
                    "output_kintone_field_code": field.output_field_code ?? "",
                    "output_kintone_field_name": field.output_field_name ?? "",
                    "kintone_field_maxValue": field.maxValue !== undefined ? (field.maxValue != "" ? field.maxValue : 0) : 0,
                    "kintone_field_minValue": field.minValue !== undefined ? (field.minValue != "" ? field.minValue : 0) : 0,
                    "kintone_field_options": field.options !== undefined ? field.options : null,
                    "feature_importance": field.feature_importance !== undefined? (field.feature_importance != "" ? field.feature_importance : 0) : 0,
                };
            });
        },
        addOutput(data) {
            if (this.aiModeType === AI_MODEL_TYPE.time_series) {
                data.output_type = AI_MODEL_OUTPUT.predict_field;
            }
            
            // remove if already predict_field exist in aiModelOutputs
            this.aiModelOutputs = this.aiModelOutputs.filter(output => output.output_type !== AI_MODEL_OUTPUT.predict_field);
            this.aiModelOutputs.push(data);
        },
        addSummarizeGroup(data) {
            this.aiModelOutputs.push({ ...data, output_type: AI_MODEL_OUTPUT.summarize_field });
        },
        addExogenousField(data) {
            this.aiModelOutputs.push({ ...data, output_type: AI_MODEL_OUTPUT.exogenous_field });
        },
        addInput(data) {
            // const self = this;
            const indexOfField = this.aiModelOutputs.indexOf(data);
            // console.log(indexOfField);
            if (indexOfField >= 0) {
                if (this.aiModelOutputs[indexOfField].output_field_code) {
                    this.aiModelSaved = this.aiModelSaved.filter(field => field.index !== indexOfField);
                }
                this.aiModelOutputs.splice(indexOfField, 1);
            }
        },
        addDateFieldToInput() {
            this.$emit('updateSummarizeKintoneDateField', {});
        },
        toggleSelectInputField(index) {
            const code = this.inputFields[index].code;
            const indexOfSelectedFieldCode = this.aiModelInputSelectedCodes.indexOf(code);
            if (indexOfSelectedFieldCode >= 0) {
                this.aiModelInputSelectedCodes.splice(indexOfSelectedFieldCode, 1);
            } else {
                this.aiModelInputSelectedCodes.push(code);
            }
        },
        progressColor(importance) {
            if (importance > 0.8) return 'progress-bar bg-success';
            else if(importance > 0.4) return 'progress-bar bg-info';
            else return 'progress-bar bg-danger';
        },
        selectAllinputItems() {
            this.aiModelInputSelectedCodes = this.inputFields.map((field) => {
                return field.code;
            });
        },
        unselectAllinputItems() {
            this.aiModelInputSelectedCodes = [];
        },
        showModal(data) {
            this.selectedAiModelOutput = data
            this.$modal.show('saving_prediction_results_modal')            
        },
        closeModal() {
            this.selectedAiModelOutput = null
            this.search_output_predict_field = ''
            this.$modal.hide('saving_prediction_results_modal')            
        },
        setOutputFieldName(code, label) {
            const index = this.aiModelOutputs.findIndex((output) => output.code === this.selectedAiModelOutput.code);
            if (index >= 0) {
                if (this.aiModelOutputs[index].output_field_code) {
                    this.aiModelSaved = this.aiModelSaved.filter(field => field.index !== index);
                }
                this.aiModelOutputs.splice(index, 1, {
                    ...this.aiModelOutputs[index],
                    output_field_code: code,
                    output_field_name: label
                });
                
                const savedField = this.aiSavingFields.find(field => field.label === label);
                if (savedField) {
                    this.aiModelSaved.push({ index, ...savedField });
                }
                this.closeModal()
            }
        },
        updateSummarizeKintoneDateField(data) {
            this.$emit('updateSummarizeKintoneDateField', data);
        },
        deleteSelectedOutputField(code) {
            Swal.fire({
                text: this.$t("ai_model.confirm_delete_output_field"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ef8157',
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    const index = this.aiModelOutputs.findIndex((output) => output.code === code);
                    if (index >= 0 && this.aiModelOutputs[index].output_field_code) {
                        this.aiModelOutputs[index].output_field_code = ""
                        this.aiModelOutputs[index].output_field_name = ""
                        this.aiModelSaved = this.aiModelSaved.filter(field => field.index !== index);
                    }
                }
            });
        },
    },
    watch: {
        aiModeType() {
            this.aiModelOutputs = []
            this.aiModelInputSelectedCodes = []
            this.aiModelPredictFields = []
            this.aiModelSummarizeFields = []
            this.aiModelExogenousFields = []
            this.search_input_field = ''
            this.search_output_predict_field = ''
            this.selectedAiModelOutput = null
            this.aiModelSaved = []
        },
        aiModelOutputs: {
            handler(newOutputs) {
                this.aiModelPredictFields = newOutputs.filter(output => output.output_type === AI_MODEL_OUTPUT.predict_field || output.output_type == null);
                this.aiModelSummarizeFields = newOutputs.filter(output => output.output_type === AI_MODEL_OUTPUT.summarize_field);
                this.aiModelExogenousFields = newOutputs.filter(output => output.output_type === AI_MODEL_OUTPUT.exogenous_field);
            },
            deep: true
        },
    },
    computed: {
        AI_MODEL_TYPE: () => AI_MODEL_TYPE,
        AI_MODEL_OUTPUT: () => AI_MODEL_OUTPUT,
        SUMMARIZE_PERIOD: () => SUMMARIZE_PERIOD,
        localSummarizePeriod: {
            get() {
                return this.summarizePeriod; 
            },
            set(value) {
                this.$emit('updateSummarizePeriod', value); 
            },
        },
        allFields() {
            // convert props oject to array and subcribe props change
            return Object.values(this.aiData);
        },
        aiSavingFields() {
            return Object.values(this.aiSavingData);
        },
        inputFields() {
            const self = this;
            const fieldInputs = this.allFields.filter(function(field) {
                const findFieldOuput = self.aiModelOutputs.find(function(fieldOutPut) {                   
                    return field.code === fieldOutPut.code;
                });
                return !findFieldOuput && field.code !== self.aiSummarizeDateField.code;
            });
            // search field input
            const searchedFieldInput = fieldInputs.filter((field) => {
                return field.label.indexOf(this.search_input_field) >= 0 || field.code.indexOf(this.search_input_field) >= 0;
            });
            const fieldInputsWithSelected = searchedFieldInput.map((field) => {
                const indexOfSelectedFieldCode = this.aiModelInputSelectedCodes.indexOf(field.code);
                field.selected = indexOfSelectedFieldCode >= 0;
                return field;
            });
            return fieldInputsWithSelected;
        },
        savingFields() {
            // Filter out fields already saved
            const availableFields = this.aiSavingFields.filter(field => 
                !this.aiModelSaved.some(savedField => savedField.label === field.label)
            );

            // Apply search filter
            const searchedFields = availableFields.filter(field => 
                field.label.includes(this.search_output_predict_field) || 
                field.code.includes(this.search_output_predict_field)
            );

            // Exclude fields with matching output_field_code in aiModelOutputs
            return searchedFields.filter(field => 
                !this.aiModelOutputs.some(output => output.output_field_code === field.code)
            );
        },
        hasExogenousCandidates() {
            const exogenousTypes = ['DROP_DOWN', 'RADIO_BUTTON', 'CHECK_BOX', 'MULTI_SELECT'];
            return this.allFields.some(field => exogenousTypes.includes(field.type));
        },
        recordQueryErrorMsg() {
            /*
            if (!this.$v.form.record_query.required) {
                return this.$t('message_error.');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }, 
    },
    validations() {
        return {
            record_query: {  },
        }
    }
}